module.exports = __webpack_public_path__ + "assets/assets/images/info/icon-tooth-computer.4be8b783.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/info/icon-tooth-computer.svg
// module id = 219
// module chunks = 0